<template>
  <footer class="footer">
        <hr>
        <div class="level">
            <div class="level-item">
                <pre>© 2045 Shine | DESIGN By<a> Template </a>Stock</pre>
            </div>
            <div class="level-right has-text-centered">
                <span class="iconify" data-icon="jam:facebook-square" data-inline="false"></span>
                <span class="iconify" data-icon="jam:twitter-square" data-inline="false"></span>
                <span class="iconify" data-icon="jam:github-square" data-inline="false"></span>
            </div>
        </div>
    </footer>
</template>
<script type="text/javascript">
export default {
  name: 'foot',
}
</script>

<style media="screen">

</style>
